export default __webpack_public_path__ + "images/4a7e459d4e5e6e41363501d478baa8a0-rebook.svg";